import { CoreEnums } from '@/utils/domain/constants';

const MENU_EXPAND_KEYS = [
  'group',
  'customList',
  'dynamicEntity',
  'report',
  'process',
  'app',
  'parent',
  'processPortalMenuGroup',
  'name',
];

const menuGroupIdOf = (item) =>
  item.processPortalMenuGroupId ?? item.groupId ?? item.group?.id ?? null;

/**
 * Full menu replacement sent to POST /processPortal/updateMenu.
 * Expanded objects stay local. A catalog item (type Apps) never carries appId or the app list.
 */
export function buildMenuSavePayload({ groups, items }) {
  const remainingGroupIds = new Set((groups || []).map((group) => group.id));

  return {
    groups: (groups || []).map((group) => ({
      id: group.id,
      title: group.title,
      order: group.order,
    })),
    items: (items || [])
      .filter((item) => {
        const menuGroupId = menuGroupIdOf(item);
        return menuGroupId == null || remainingGroupIds.has(menuGroupId);
      })
      .map((item) => {
        const { group: _drop, processPortalMenuGroupId, groupId: formGroupId, ...rest } = item;
        const menuGroupId = processPortalMenuGroupId ?? formGroupId;
        const payload = {
          ...rest,
          ...(menuGroupId != null ? { groupId: menuGroupId } : {}),
        };
        if (payload.type === CoreEnums.PortalMenuItemType.Apps) {
          delete payload.appId;
          delete payload.apps;
        }
        return Object.fromEntries(
          Object.entries(payload).filter(
            ([key, value]) => value != null && !MENU_EXPAND_KEYS.includes(key),
          ),
        );
      }),
  };
}
